import { Key, Shield, Activity, Settings as SettingsIcon, Unlock } from "lucide-react";

export const CONNECTION_METHODS = [
  { id: "apikey", label: "API Key", icon: Key },
  { id: "mcp", label: "MCP", icon: Shield },
  { id: "oauth", label: "OAuth", icon: Activity },
  { id: "webhook", label: "Webhook", icon: SettingsIcon },
  { id: "noauth", label: "No Auth", icon: Unlock }
];

export const PERMISSION_OPTIONS = [
  { id: "readAccess", label: "Read access" },
  { id: "writeAccess", label: "Write access" },
  { id: "executeWorkflows", label: "Execute workflows" },
  { id: "adminPrivileges", label: "Admin privileges" }
];

export const EVENT_TYPE_OPTIONS = [
  { id: "dataUpdates", label: "Data updates" },
  { id: "statusChanges", label: "Status changes" },
  { id: "errorNotifications", label: "Error notifications" },
  { id: "systemAlerts", label: "System alerts" }
];

export const TABS = [
  { id: "authentication", label: "Authentication" },
  { id: "settings", label: "Settings" },
  { id: "monitoring", label: "Monitoring" }
];
